import { FC, ReactNode } from 'react'
import { createPortal } from 'react-dom'

type ScreenReaderInfoProps = {
  id?: string
  ariaLive?: 'off' | 'assertive' | 'polite'
  ariaBusy?: boolean
  ariaAtomic?: boolean
  role?: string
  children?: ReactNode
}

export const ScreenReaderInfo: FC<ScreenReaderInfoProps> = props => {
  const { id, children, ariaLive, ariaAtomic, ariaBusy, role } = props
  const ariaAttributes = {
    ...(ariaLive && { 'aria-live': ariaLive }),
  }
  return createPortal(
    <div
      id={id}
      {...ariaAttributes}
      aria-atomic={ariaAtomic}
      aria-busy={ariaBusy}
      role={role}
      className='sr-only'
    >
      {children}
    </div>,
    document.body,
  )
}
